import UploadButton from "./UploadButton";

const UploadNewFileButton = ({ onChange, disabled, accept, buttonProps }) => {
  return (
    <UploadButton
      onChange={onChange}
      disabled={disabled}
      label="Upload New File"
      buttonProps={{
        variant: "contained",
        color: disabled ? "primary" : "secondary",
        sx: {
          pr: 1.5,
          pl: 1,
          py: 0,
          lineHeight: "35px",
          borderRadius: "20px",
          width: 145,
        },
        startIcon: <img src={`assets/buttons/add${disabled ? "-disabled" : ""}.svg`} alt="Upload New File" />,
        ...buttonProps,
      }}
      inputProps={{ accept: accept }}
    ></UploadButton>
  );
};

export default UploadNewFileButton;
